import { createSelector } from 'reselect'
import { ContentUserRole, InviteWithQualificationsResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getQualificationsForInvitesEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { getHasInvitePermission } from '@tabeeb/modules/permissions/selectors'
import { getUsersListForCurrentUser } from '../../../users/selectors'

export const getShowManageQualificationsMenuItem = createSelector(
  [
    getQualificationsForInvitesEnabled,
    getHasInvitePermission,
    getUsersListForCurrentUser,
    (_, { invite }: { invite: InviteWithQualificationsResponse }) => invite,
  ],
  (qualificationsForInvitesEnabled, hasInvitePermission, usersList, invite) => {
    if (!qualificationsForInvitesEnabled || !hasInvitePermission) {
      return false
    }

    const user = usersList.find((u) => u.id === invite.RecipientId)

    if (!user) {
      return true
    }

    return ![ContentUserRole.Owner, ContentUserRole.Reviewer].includes(user.role)
  }
)
